module.exports = __webpack_public_path__ + "static/media/IMG_0537.22cb7420.JPG";